import type { TOC } from '@ember/component/template-only';
import type { Signature as BaseAntecedantFieldsSignature } from 'parog-web/components/medical-history/onco/base-antecedents-fields';
import type Patient from 'parog-web/models/patient';
import BaseAntecedentsFields from '../base-antecedents-fields';

interface Signature {
  Args: {
    form: BaseAntecedantFieldsSignature['Args']['form'];
    patient: Patient;
  };
}

export default <template>
  <BaseAntecedentsFields @form={{@form}} @patient={{@patient}} />
</template> satisfies TOC<Signature>;
